export default "__VITE_ASSET__D730uGpq__"